<template>
  <div class="checkout-builder-image-preview">
    <img :src="component.image" alt="imagem" :style="style" />
  </div>
</template>

<script>
export default {
  props: {
    component: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    style() {
      const style = { ...this.component.config };

      return style;
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-builder-image-preview {
  img {
    object-fit: cover;
  }
}
</style>
